import React from 'react';
import CtaButton from './CtaButton';

function FinalCta() {
  return (
    <>
      <section className="final-cta navy-section">
        <div className="shell final-cta-inner">
          <div>
            <p className="eyebrow">Your next conversation is coming</p>
            <h2>Know what to say before you walk into the room.</h2>
          </div>
          <CtaButton light>Get the toolkit</CtaButton>
        </div>
      </section>
      <footer>
        <div className="shell footer-inner">
          <strong>Key Future Skills</strong>
          <p>
            Leadership development for people who got promoted before anyone
            taught them how.
          </p>
        </div>
      </footer>
    </>
  );
}

export default FinalCta;